module.exports = __webpack_public_path__ + "img/Chest-1-1.795186f6.png";